import React, { useRef, useState } from "react";
import search from "../../../assets/images/search.svg";

interface SearchBarProps {
  placeholder: string;
  onSearch: (query: string) => void;
  searchTerm: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder,
  onSearch,
  searchTerm,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isFocused, setIsFocused] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearch(e.target.value);
    // Force re-render on iOS WebView
    if (inputRef.current) {
      inputRef.current.style.opacity = "0.99";
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.style.opacity = "1";
        }
      }, 10);
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
    // Delay to ensure WebView handles focus properly
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        // Force cursor to end of input
        const length = inputRef.current.value.length;
        inputRef.current.setSelectionRange(length, length);
      }
    }, 100);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <div className="flex overflow-hidden gap-3 items-center px-4 py-3 w-full text-base bg-white rounded-xl border border-solid border-slate-300 min-h-[48px] shadow-[0px_0px_20px_rgba(0,0,0,0.1)] text-slate-400">
      <img
        loading="lazy"
        src={search}
        alt=""
        className="object-contain shrink-0 self-stretch my-auto w-6 aspect-square"
      />
      <input
        ref={inputRef}
        type="text"
        placeholder={placeholder}
        className="gap-1 self-stretch my-auto bg-white border-none outline-none flex-grow"
        aria-label={placeholder}
        onChange={handleInputChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        value={searchTerm}
        style={{
          // iOS WebView specific fixes
          WebkitAppearance: "none",
          WebkitUserSelect: "text",
          userSelect: "text",
          transform: "translateZ(0)",
          WebkitTransform: "translateZ(0)",
          willChange: "contents",
          // Force re-render when focused to show cursor
          opacity: isFocused ? 0.99 : 1,
          // Ensure text color is visible
          color: searchTerm ? "#475569" : "#94a3b8",
        }}
        // iOS specific attributes
        autoCapitalize="off"
        autoCorrect="off"
        spellCheck="false"
      />
    </div>
  );
};

export default SearchBar;
